import React, { Component } from "react";
import { Card, Switch, Button, InputGroup, FormGroup, Icon } from "@blueprintjs/core";
import { BASE_API, AppToaster, COLORS } from "../../utils/constants";
import UiDialog from '../../components-fm/UiDialog';
import { getSession } from "../../utils/helpers";
import { PLAYER_POSITIONS, PLAYERS_STATUS } from '../../utils/constants'
import UISelect from '../../components-fm/UISelect'
import "../../css/SuperAdminDashboard.scss";

class Players extends Component {
    constructor(props) {
        super(props);
        this.state = {
            players: [],
            editing: {},

            loading: true,
            error: null,
            searchTerm: "",
            filter: "",
            showAddDialog: false,
            isConfirmPlayerDeleteOpen: false,
            name: "",
            position: "",
            number: "",
            nickname: "",
            birth_date: "",
            errors: {
                name: '',
                position: '',
                birth_date: '',
            },
        };

        this.handleEdit = this.handleEdit.bind(this);
        this.handleSave = this.handleSave.bind(this);

    }


    componentDidMount() {
        const wrapper = document.getElementById('echipaDashboard');
        if (wrapper) {
            wrapper.classList.add('layout-xl-width');
        }
        this.getData();
    }

      componentWillUnmount() {
        const wrapper = document.getElementById('echipaDashboard');
        if (wrapper) {
            wrapper.classList.remove('layout-xl-width');
        }
    }

    async getData() {
        try {
            const session = getSession();
            const teamId = session?.team?.id;

            if (!teamId) {
                this.setState({ error: "Echipa nu a fost selectată", loading: false });
                return;
            }

            const res = await fetch(`${BASE_API}/api/team-players/${teamId}`);
            const data = await res.json();

            if (!res.ok) {
                throw new Error(data?.error || "Eroare la încărcarea jucătorilor.");
            }

            this.setState({ players: data.players || [], loading: false });
        } catch (err) {
            this.setState({ error: err.message || "Eroare necunoscută", loading: false });
        }
    }




    handleSearch = (e) => {
        this.setState({ searchTerm: e.target.value });
    };

    handleFilter = (filter) => {
        this.setState({ filter });
    };

    isOpenPopupAddPlayer = () => {
        this.setState((prev) => ({ showAddDialog: !prev.showAddDialog }));
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        const errors = { ...this.state.errors };

        // Validări doar pentru cele obligatorii
        if (name === 'name') {
            errors.name = value.trim() !== "" ? "" : "Numele este obligatoriu.";
        }

        if (name === 'position') {
            errors.position = value.trim() !== "" ? "" : "Poziția este obligatorie.";
        }

        if (name === 'birth_date') {
            errors.birth_date = value ? "" : "Data nașterii este obligatorie.";
        }

        this.setState({ [name]: value, errors });
    };


    isFormValid = () => {
        const { name, position, birth_date, errors } = this.state;
        return (
            name && position && birth_date &&
            !errors.name && !errors.position && !errors.birth_date
        );
    };


    handleAddPlayer = async () => {
        const session = getSession();
        const teamId = session?.team?.id;

        const { name, position, number, nickname, birth_date } = this.state;

        const payload = {
            team_id: teamId,
            name,
            position,
            number: number || null,
            nickname: nickname || null,
            birth_date,
        };

        try {
            const res = await fetch(`${BASE_API}/api/player/create`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            const data = await res.json();

            if (!res.ok) {
                throw new Error(data?.message || "Eroare la salvare.");
            }

            AppToaster.show({ message: "Jucător adăugat cu succes!", intent: "success" });

            // Resetare formular
            this.setState({
                name: "",
                position: "",
                number: "",
                nickname: "",
                birth_date: "",
                showAddDialog: false,
            });

            // (Optional) Reîncarcă lista de date dacă e cazul
            this.getData();

        } catch (err) {
            AppToaster.show({ message: err.message || "Eroare la adăugare jucător.", intent: "danger" });
        }
    };

    handleEdit = (id, field, value) => {
        this.setState((prevState) => ({
            editing: {
                ...prevState.editing,
                [id]: {
                    ...prevState.editing[id],
                    [field]: value,
                },
            },
        }));
    };

    handleSave = async (id, field) => {
        const updatedValue = this.state.editing[id]?.[field];
        if (updatedValue === undefined) return;

        try {
            const res = await fetch(`${BASE_API}/api/player/update`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    id,
                    field,
                    value: updatedValue,
                }),
            });

            const data = await res.json();
            if (!res.ok) throw new Error(data?.error || "Eroare la salvare");

            AppToaster.show({ message: "Jucător actualizat cu succes", intent: "success" });

            // Actualizează local
            this.setState((prevState) => ({
                players: prevState.players.map((p) =>
                    p.id === id ? { ...p, [field]: updatedValue } : p
                ),
                editing: {
                    ...prevState.editing,
                    [id]: {
                        ...prevState.editing[id],
                        [field]: undefined, // clear local editing
                    },
                },
            }));
        } catch (err) {
            AppToaster.show({ message: err.message || "Eroare la actualizare", intent: "danger" });
        }
    };

    confirmPlayerDrop = () => {
		this.setState((prev) => ({
            isConfirmPlayerDeleteOpen: !prev.isConfirmPlayerDeleteOpen,
        }));
	}


    render() {
        // console.log(this.state)
        const {
            loading, error, searchTerm, players, editing,
            errors, showAddDialog, isConfirmPlayerDeleteOpen, userToDelete
        } = this.state;

        let filtered = players.filter((p) => { return p.name.toLowerCase().includes(searchTerm.toLowerCase()) && p.is_active }
        );

        if (loading) return <p>Se încarcă...</p>;
        if (error) return <p>{error}</p>;
        // console.log(players)
        return (
            <div className='p-2-rem p-0-ss'>
                <div className="dashboard-header" id="players">
                    {/* Filters */}
                    {/* <div className="header-filters">
                        <Button text={`Organizatii: ${organizations.length}`} minimal onClick={() => this.handleFilter("")} className={this.state.filter === "" ? "active" : ""} />
                        <Button text={`Active: ${organizations.filter(o => o.approved).length}`} minimal onClick={() => this.handleFilter("approved")} className={this.state.filter === "approved" ? "active" : ""} />
                        <Button text={`Inactive: ${organizations.filter(o => !o.approved).length}`} minimal onClick={() => this.handleFilter("unapproved")} className={this.state.filter === "unapproved" ? "active" : ""} />
                    </div> */}
                    {/* Header actions */}
                    <div className="header-actions">
                        <InputGroup
                            leftIcon="search"
                            placeholder="Caută jucator..."
                            value={searchTerm}
                            onChange={this.handleSearch}
                        />
                        <Button className="seagreen btn-medium" onClick={this.isOpenPopupAddPlayer}>
                            Adaugă
                        </Button>
                    </div>
                </div>

                <div className='table-wrapper'>
                    {players && (
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Nume</th>
                                    <th>Nume 2</th>
                                    <th>Status</th>
                                    <th>Poziție</th>
                                    <th>Data nașterii</th>
                                    <th>Număr</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map((p, key) => (
                                    <tr key={p.id}>
                                        <td>{key + 1}</td>
                                        <td>
                                            <InputGroup
                                                fill={true}
                                                style={{ minWidth: "160px" }}
                                                value={editing[p.id]?.name ?? p.name ?? ""}
                                                onChange={(e) => this.handleEdit(p.id, "name", e.target.value)}
                                                onBlur={() => this.handleSave(p.id, "name")}
                                                onKeyDown={(e) => e.key === "Enter" && this.handleSave(p.id, "name")}
                                            />
                                        </td>

                                        {/* Nickname */}
                                        <td>
                                            <InputGroup
                                                fill={true}
                                                style={{ minWidth: "120px" }}
                                                value={editing[p.id]?.nickname ?? p.nickname ?? ""}
                                                onChange={(e) => this.handleEdit(p.id, "nickname", e.target.value)}
                                                onBlur={() => this.handleSave(p.id, "nickname")}
                                                onKeyDown={(e) => e.key === "Enter" && this.handleSave(p.id, "nickname")}
                                            />
                                        </td>

                                        {/* Status */}
                                        <td>
                                            <div className="bp4-select fill transparent-select status-select">
                                                <UISelect
                                                    items={PLAYERS_STATUS.map(s => ({ id:s.key, name: s.key, icon: s.icon }))}
                                                    selectedItem={{ id: p.status ?? "active", name: p.status ?? "active", icon: PLAYERS_STATUS?.filter(
                                                        s => {
                                                            p.status = p.status ? p.status: 'active'; 
                                                            return s.key === p.status ?? "active"
                                                        })?.[0]?.icon
                                                    }}
                                                    onItemSelect={(s) => {
                                                        if( s.id === 'inactive'){
                                                            this.handleEdit(p.id, "is_active", 0);
                                                            setTimeout(() => this.handleSave(p.id, "is_active"), 0.2);

                                                        }else{
                                                            this.handleEdit(p.id, "status", s.id);
                                                            setTimeout(() => this.handleSave(p.id, "status"), 0.2);
                                                        }
                                                    }}
                                                    className='transparent-select'
                                                />
                                            </div>
                                        </td>
                                        
                                        {/* Position */}
                                        <td>
                                            <div className="bp4-select fill transparent-select">
                                                <UISelect
                                                    items={PLAYER_POSITIONS.map(pl => ({ id: pl.code, name: pl.code }))}
                                                    selectedItem={
                                                        PLAYER_POSITIONS.map(pl => ({ id: pl.code, name: pl.code }))
                                                            .find((pl) => pl.id === (editing[p.id]?.position ?? p.position))
                                                    }
                                                    onItemSelect={(pl) => {
                                                        this.handleEdit(p.id, "position", pl.id);
                                                        setTimeout(() => this.handleSave(p.id, "position"), 0.2);
                                                    }}
                                                    // this.setState({ selectedPosition: p })}
                                                    placeholder="Alege..."
                                                    className='transparent-select'
                                                />
                                            </div>
                                        </td>
                                        
                                        {/* BirthDate */}
                                        <td>
                                            <InputGroup
                                                type="date"
                                                value={editing[p.id]?.birth_date ?? p.birth_date ?? ""}
                                                onChange={(e) => this.handleEdit(p.id, "birth_date", e.target.value)}
                                                onBlur={() => this.handleSave(p.id, "birth_date")}
                                                onKeyDown={(e) => e.key === "Enter" && this.handleSave(p.id, "birth_date")}
                                                min="1980-01-01"
                                                max="2025-12-31"
                                            />
                                        </td>
                                        <td>
                                            <InputGroup
                                                fill={true}
                                                style={{ minWidth: "60px" }}
                                                value={editing[p.id]?.number ?? p.number ?? ""}
                                                onChange={(e) => this.handleEdit(p.id, "number", e.target.value)}
                                                onBlur={() => this.handleSave(p.id, "number")}
                                                onKeyDown={(e) => e.key === "Enter" && this.handleSave(p.id, "number")}
                                            />
                                        </td>
                                        <td>
                                            <Icon icon="trash"
                                                onClick={() => {
                                                    this.setState({userToDelete: {id: p.id, name: p.name}})
                                                    this.handleEdit(p.id, "is_active", false);
                                                    this.confirmPlayerDrop();
                                                }}

                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                </div>

                {
                    <UiDialog
                        isOpen={showAddDialog}
                        onClose={this.isOpenPopupAddPlayer}
                        title="Adaugă jucator"
                        footer={
                            <>
                                <Button className="alert-bordered btn-medium" onClick={this.isOpenPopupAddPlayer}>Anulează</Button>
                                <Button className="seagreen btn-medium" onClick={this.handleAddPlayer} disabled={!this.isFormValid()}>Salvează</Button>
                            </>
                        }
                    >
                        <FormGroup label="Nume" intent={errors.name ? "danger" : "none"} helperText={errors.name}>
                            <InputGroup name="name" value={this.state.name} onChange={this.handleInputChange} intent={errors.name ? "danger" : "none"} />
                        </FormGroup>

                        {/* <FormGroup label="Poziție" intent={errors.position ? "danger" : "none"} helperText={errors.position}>
                            <InputGroup name="position" value={this.state.position} onChange={this.handleInputChange} intent={errors.position ? "danger" : "none"} />
                        </FormGroup> */}
                        <FormGroup label="Poziție" intent={errors.position ? "danger" : "none"} helperText={errors.position}>
                            <div className="bp4-select fill dialog-select">
                                <UISelect
                                    items={PLAYER_POSITIONS.map(pl => ({ id: pl.code, name: pl.code }))}
                                    selectedItem={
                                        PLAYER_POSITIONS.map(pl => ({ id: pl.code, name: pl.code }))
                                            .find((pl) => pl.id === this.state.position)
                                    }
                                    onItemSelect={(pl) => this.setState({ position: pl.id })}
                                    placeholder="Alege..."
                                />

                            </div>
                        </FormGroup>


                        <FormGroup label="Număr (opțional)">
                            <InputGroup name="number" value={this.state.number} onChange={this.handleInputChange} />
                        </FormGroup>

                        <FormGroup label="Poreclă (opțional)">
                            <InputGroup name="nickname" value={this.state.nickname} onChange={this.handleInputChange} />
                        </FormGroup>

                        <FormGroup label="Data nașterii" intent={errors.birth_date ? "danger" : "none"} helperText={errors.birth_date}>
                            <InputGroup
                                name="birth_date"
                                type="date"
                                value={this.state.birth_date}
                                onChange={this.handleInputChange}
                                intent={errors.birth_date ? "danger" : "none"}
                                min="1980-01-01"
                                max="2025-12-31"
                            />
                        </FormGroup>
                    </UiDialog>

                }

                {/* Drop  player */}
                <UiDialog
                    isOpen={isConfirmPlayerDeleteOpen}
                    onClose={this.confirmPlayerDrop}
                    title="Șterge jucator"
                    footer={
                        <>
                            <Button className="alert-bordered btn-medium" onClick={this.confirmUserDrop}>Anulează</Button>
                            <Button className="alert btn-medium" onClick={()=>{
                                this.handleSave(userToDelete.id, "is_active");
                                this.setState({userToDelete: undefined});
                                this.confirmPlayerDrop();
                            }}>Șterge</Button>
                        </>
                    }
                >
                    <div>
                        Confirmi ștergerea userului <strong>{this.state.userToDelete?.name}</strong>?
                    </div>
                </UiDialog>
            </div>
        );
    }
}

export default Players;
